module.exports = __webpack_public_path__ + "img/intelligentService-1.519fa3dc.png";